import React, { SyntheticEvent } from 'react';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import styled from 'styled-components/macro';
import { Paper } from '@material-ui/core';
import { openTab } from '../utils/open-tab';
import { Heading2 } from './common/Heading2';
import { customIdFromText } from '../utils/customIdFromJsx';
import TableImage from './SimpleTable/TableImage';
import { useAffiliateProgramsContext } from '../context/AffiliateProgramsContext';
import makeAffiliateUrl from '../utils/affiliateUrl/makeAffiliateUrl';

const SButton = styled(Button)`
  padding: 24px;
  font-size: 24px;
`;

const SBox = styled(Box)`
  display: flex;
  flex-direction: column;
  margin: 24px 0;
  padding: 12px;

  ${SButton} {
    margin-top: 12px;
    align-self: center;
  }
`;

type ContentfulProductReviewProps = {
  affiliateUrl: string;
  children: React.ReactElement;
  title: string;
  productImage: { fileName: string; alt: string };
  productName: string;
};

const ContentfulProductReview: React.FC<ContentfulProductReviewProps> = ({
  children,
  affiliateUrl,
  title,
  productImage,
  productName,
}: ContentfulProductReviewProps) => {
  const affiliatePrograms = useAffiliateProgramsContext();
  const actuallyAffiliateUrl = makeAffiliateUrl(
    affiliateUrl,
    affiliatePrograms,
    productName
  );
  return (
    <SBox data-product as={Paper} variant="outlined">
      {productImage.fileName && (
        <TableImage
          fileName={productImage.fileName}
          alt={productImage.alt}
          affiliateUrl={actuallyAffiliateUrl}
        />
      )}
      <Heading2 id={customIdFromText(title)}>{title}</Heading2>
      {children}
      {affiliateUrl && (
        <SButton
          onClick={(e: SyntheticEvent): void =>
            openTab(e, actuallyAffiliateUrl)
          }
          variant="contained"
          color="secondary"
        >
          Kjøp nå
        </SButton>
      )}
    </SBox>
  );
};

export default ContentfulProductReview;
